import { render, staticRenderFns } from "./EventLocation.vue?vue&type=template&id=ee920b70"
import script from "./EventLocation.vue?vue&type=script&lang=js"
export * from "./EventLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports